import styled from 'styled-components'

export const ParentContactContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 5fr;
  height: 95vh;
`

export const ParentContactTitle = styled.div`
  font-size: 4vw;
  display: grid;
  grid-template-columns: 5fr 1fr;
`
